/* !
 * jQuery products v1.0.0
 * Copyright 2017, Connecty Inc.
 */
(function($, NSKW, cssua){
	const a = 'is-active';
	const v = 'is-visible';
	const map1 = NSKW.va.pathname.split('/')[1];
	const search = location.search;
	let map2 = '', cat, brand, purpose, tags;
	const navText = [
		'<i class="icon icon-arrow_left"></i>',
		'<i class="icon icon-arrow_right"></i>'
	];

	if (map1 === 'categories') {
		if (NSKW.va.pathname.split('/')[2].indexOf('.html') === -1) {
			cat = NSKW.va.pathname.split('/')[2];
			map2 = NSKW.va.pathname.split('/')[3];
		} else if (NSKW.va.pathname.split('/')[2] !== 'index.html') {
			cat = NSKW.va.pathname.split('/')[2].replace('.html', '');
		}
	} else if (map1 === 'brands') {
		brand = NSKW.va.pathname.split('/')[2];
		map2 = NSKW.va.pathname.split('/')[4];
	} else if (map1 === 'products') {
		if (NSKW.va.pathname.split('/')[2] === 'tags') {
			tags = NSKW.va.pathname.split('/')[2];
			map2 = NSKW.va.pathname.split('/')[3];
		} else {
			map2 = NSKW.va.pathname.split('/')[2];
		}
	} else if (map1 === 'purpose') {
		purpose = NSKW.va.pathname.split('/')[2];
		map2 = NSKW.va.pathname.split('/')[3];
	} else if (map1 === 'contents') {
		if (NSKW.va.pathname.split('/')[2] === 'care') {
			map2 = NSKW.va.pathname.split('/')[3].replace(/\.html/g, '');
		}
	}
	if (cat && !map2) {
		if (cat.indexOf('comforters') !== -1) {
			cat = 'comforters';
			map2 = NSKW.va.pathname.split('/')[2];
		} else {
			map2 = 'index.html';
		}
	}

	// ＜共通＞商品一覧 要素の高さ合わせ
	$('.mod-prodItem-mark').matchHeight();
	$('.mod-prodItem figcaption').matchHeight();
	$('.mod-prodItem-name').matchHeight();

	// ＜共通＞サイズタグリンク ※お気に入りページのみ別トリガー
	if(map2 !== 'favorite.html') {
		checkSizeTagLink();
	}

	// ＜カテゴリ一覧／ブランド一覧／目的別一覧＞2ページ目以降（searchなしのindex.html以外）ではrelation、おすすめ商品は表示しない
	// ※お手入れページにも表示あり
	if (((brand || cat || purpose) && (map2 === 'index.html' || map2 === '') && search.indexOf('size=') === -1 &&
		search.indexOf('keyword=') === -1 && search.indexOf('brand=') === -1 && search.indexOf('color=') === -1 &&
		search.indexOf('skip=') === -1) || map1 === 'contents') {

		$('.js-onceView').addClass(v);

		$('.categories-recommend-slider').owlCarousel({
			margin: 30,
			nav: true,
			loop: false,
			smartSpeed: 500,
			navText: navText,
			responsive: {
				640: {
					items: 4
				},
				320: {
					items: 1,
					stagePadding: 50
				}
			}
		});
	} else {
		if (brand) { $('.mod-head01-brands').addClass('mod-borderBottom'); }
	}

	// ＜カテゴリ一覧／ブランド一覧／目的別一覧＞詳細検索リンク生成
	// ※ページングとGAは引き継がない。商品詳細検索に渡すときはthisSearchのみ利用
	let thisSearch = '';
	let searchArray = [];
	if (search) {
		searchArray = search.slice(1).split('&');
		searchArray.forEach(function(val){
			if (val.indexOf('skip') === -1 && val.indexOf('_ga=') === -1) {
				thisSearch += '&' + val;
			}
		});
	}
	if (cat) {
		if (cat !== 'comforters') {
			$('.js-moreSearch').attr('href', '/products/' + map2.replace(/index/g, 'search') + '?category=' + cat + thisSearch);
		} else { // 掛け布団
			$('.js-moreSearch').attr('href', '/products/' + map2.replace(/comforters/g, 'search') + '?category_l=' + cat + thisSearch);
		}
	} else if (brand) {
		if (map2) {
			$('.js-moreSearch').attr('href', '/products/' + map2.replace(/index/g, 'search') + '?brand=' + brand + thisSearch);
		} else {
			$('.js-moreSearch').attr('href', '/products/search.html?brand=' + brand + thisSearch);
		}
	} else if (purpose) {
		if (map2) {
			$('.js-moreSearch').attr('href', '/products/' + map2.replace(/index/g, 'search_purpose') + '?purpose=' + purpose + thisSearch);
		} else {
			$('.js-moreSearch').attr('href', '/products/search_purpose.html?purpose=' + purpose + thisSearch);
		}
	}

	// ＜カテゴリ一覧／ブランド一覧／目的別一覧／商品詳細検索／タグ商品一覧＞表示件数変更・並び替え
	let $selectCount = $('.js-selectViewCount');
	let $selectSort = $('.js-selectViewSort');
	let thisCount, thisSort, selectMap;
	if (tags) {
		selectMap = NSKW.va.pathname.split('/')[4];
	} else {
		selectMap = map2;
	}
	if ($selectCount[0]) {
		if (selectMap.indexOf('20') !== -1) {
			thisCount = '20';
			$selectCount.val(thisCount);
		} else {
			$selectCount.val('40');
		}
		if (selectMap.indexOf('_purpose') !== -1) {
			if (selectMap.indexOf('high') !== -1) {
				thisSort = 'high_purpose';
			} else if (selectMap.indexOf('low') !== -1) {
				thisSort = 'low_purpose';
			} else if (selectMap.indexOf('pattern') !== -1) {
				thisSort = 'pattern_purpose';
			} else if (selectMap.indexOf('category') !== -1) {
				thisSort = 'category_purpose';
			} else {
				thisSort = 'search_purpose';
			}
		} else if (selectMap.indexOf('comforters') !== -1) {
			if (selectMap.indexOf('high') !== -1) {
				thisSort = 'high';
			} else if (selectMap.indexOf('low') !== -1) {
				thisSort = 'low';
			} else if (selectMap.indexOf('category') !== -1) {
				thisSort = 'category';
			} else {
				thisSort = 'index';
			}
		} else if (tags) {
			if (selectMap.indexOf('high') !== -1) {
				thisSort = 'high';
			} else if (selectMap.indexOf('low') !== -1) {
				thisSort = 'low';
			} else if (selectMap.indexOf('category') !== -1) {
				thisSort = 'category';
			} else {
				thisSort = 'index';
			}
		} else {
			if (selectMap.indexOf('high') !== -1) {
				thisSort = 'high';
			} else if (selectMap.indexOf('low') !== -1) {
				thisSort = 'low';
			} else if (selectMap.indexOf('pattern') !== -1) {
				thisSort = 'pattern';
			} else if (selectMap.indexOf('category') !== -1) {
				thisSort = 'category';
			} else {
				if (cat || brand || purpose || tags) {
					thisSort = 'index';
				} else {
					thisSort = 'search';
				}
			}
		}
		$selectSort.val(thisSort);

		$selectCount.on('change', (e) => {
			let href = '/' + location.pathname.split('/')[1] + '/';
			if (cat) {
				if (cat !== 'comforters') { // 掛け布団以外
					href += location.pathname.split('/')[2] + '/';
				}
			} else if (brand || tags) {
				href += location.pathname.split('/')[2] + '/';
				href += location.pathname.split('/')[3] + '/';
			} else if (purpose) {
				href += location.pathname.split('/')[2] + '/';
			}

			if (cat) {
				if (cat === 'comforters') { // 掛け布団
					let sortURL = thisSort;
					if (sortURL !== 'index') { sortURL = `_${sortURL}`; }
					else { sortURL = ''; }

					if ($(e.currentTarget).val() === '20') {
						href += `comforters${sortURL}_${$(e.currentTarget).val()}.html`;
					} else {
						href += `comforters${sortURL}.html`;
					}
				} else {
					if ($(e.currentTarget).val() === '20') {
						href += `${thisSort}_${$(e.currentTarget).val()}.html`;
					} else {
						href += `${thisSort}.html`;
					}
				}
			} else {
				if ($(e.currentTarget).val() === '20') {
					href += `${thisSort}_${$(e.currentTarget).val()}.html`;
				} else {
					href += `${thisSort}.html`;
				}
			}

			if (thisSearch) { href += '?' + thisSearch.slice(1); }

			location.href = href;
		});

		$selectSort.on('change', (e) => {
			let href = '/' + location.pathname.split('/')[1] + '/';
			if (cat) {
				if (cat !== 'comforters') { // 掛け布団以外
					href += location.pathname.split('/')[2] + '/';
				}
			} else if (brand || tags) {
				href += location.pathname.split('/')[2] + '/';
				href += location.pathname.split('/')[3] + '/';
			} else if (purpose) {
				href += location.pathname.split('/')[2] + '/';
			}

			if (cat) {
				if (cat === 'comforters') { // 掛け布団
					let sortURL = thisSort;
					if (sortURL !== 'index') { sortURL = `_${sortURL}`; }
					else { sortURL = ''; }
					if ($(e.currentTarget).val() !== 'index') {
						href += `comforters_${$(e.currentTarget).val()}`;
					} else {
						href += 'comforters';
					}
				} else {
					href += $(e.currentTarget).val();
				}
			} else {
				href += $(e.currentTarget).val();
			}

			if (thisCount) { href += '_' + thisCount; }
			href += '.html';
			if (thisSearch) { href += '?' + thisSearch.slice(1); }

			location.href = href;
		});
	}

	// ＜カテゴリ一覧／ブランド一覧／目的別一覧／商品詳細検索＞ページネーションにスタイル用class追加
	if ($('.mod-paginate')[0]) {
		$('.mod-paginate').find('span').each((idx, ele) => {
			if ($(ele).attr('class').indexOf('page-selected') !== -1) {
				$(ele).addClass('mod-paginate-index');
			}
		});
	}

	// ＜カテゴリ一覧＞おすすめ商品が空の場合枠を削除
	if (!$('.categories-relation').find('div')[0]) {
		$('.categories-relation').remove();
	}
	// ＜カテゴリ一覧＞絞り込み検索なしの場合h1内の枠を削除/titleの空欄を削除
	if (!$('.mod-head01-leadTitle-search').find('span')[0]) {
		$('.mod-head01-leadTitle-search').remove();
	}

	// ＜カテゴリ一覧／目的別一覧＞サイズ・素材・キーワード・ブランド絞込 / パンくず・title作成
	const setSearchItemsAndTopicPath = () => {
		let thisSearchSize = '', thisSearchMaterial = '', thisSearchKeyword = '', thisSearchBrand = '';
		let thisSearchBrandName = '';
		if (search) {
			searchArray.forEach((val) => {
				// 現在の検索条件を点灯
				let name = val.split('=')[0];
				let value = val.split('=')[1];
				value = decodeURIComponent(value);
				if ($('#' + name)[0]) {
					$('[data-name=' + name + ']').each((idx, ele) => {
						if (name === 'brand') {
							if ($(ele).attr('data-value') === value) {
								thisSearchBrandName = $(ele).text();
								$(ele).addClass(a);
								$('#' + name).text(thisSearchBrandName).addClass('selected');

								// SEO施策テキスト
								$('.selected_param').append('「' + thisSearchBrandName + '」');
							}
						} else {
							if ($(ele).text() === value) {
								$(ele).addClass(a);
								$('#' + name).text(value).addClass('selected');

								// SEO施策テキスト
								$('.selected_param').append('「' + value + '」');
							}
						}
					});
				}

				// リンク作成のためパラメータ保存
				if (val.indexOf('size=') !== -1) {
					thisSearchSize += val;
				} else if (val.indexOf('material=') !== -1) {
					thisSearchMaterial += val;
				} else if (val.indexOf('keyword=') !== -1) {
					thisSearchKeyword += val;
				} else if (val.indexOf('brand=') !== -1) {
					thisSearchBrand += val;
				}

			});

			// パンくず・title作成
			let breadHTML = '', titleTxt = $('title').text();
			let content = 4;

			// 中カテゴリがあるものは階層を一つ下げる
			if (cat) {
				if (cat === 'down' || cat === 'synthetic' || cat === 'silk' || cat === 'ramie' || cat === 'floor-mattress' || cat === 'bed-mattress') { content++; }
			}

			const setTopicPath = (_name, _search, _content) => {
				return '<li class="mod-topicPath-li" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">' +
					'<a class="mod-topicPath-a" itemprop="item" href="' + NSKW.va.pathname + _search + '">' +
					'<span class="mod-topicPath-span" itemprop="name">' + _name + '</span>' +
					'</a><meta itemprop="position" content="' + _content.toString() + '" /></li>';
			};

			let decodeSize = (thisSearchSize) ? decodeURIComponent(thisSearchSize.replace(/size=/, '')) : '';
			let decodeMaterial = (thisSearchMaterial) ? decodeURIComponent(thisSearchMaterial.replace(/material=/, '')) : '';
			let decodeKeyword = (thisSearchKeyword) ? decodeURIComponent(thisSearchKeyword.replace(/keyword=/, '')) : '';

			if (thisSearchSize) {
				// サイズ
				breadHTML += setTopicPath(decodeSize, `?${thisSearchSize}`, content);
				titleTxt = `${decodeSize}｜${titleTxt}`;

				if (thisSearchMaterial) {
					// サイズ + 素材
					breadHTML += setTopicPath(`${decodeSize}・${decodeMaterial}`, `?${thisSearchSize}&${thisSearchMaterial}`, content + 1);
					titleTxt = `${decodeMaterial}｜${titleTxt}`;

					if (thisSearchKeyword) {
						// サイズ + 素材 + キーワード
						breadHTML += setTopicPath(
							`${decodeSize}・${decodeMaterial}・${decodeKeyword}`,
							`?${thisSearchSize}&${thisSearchMaterial}&${thisSearchKeyword}`, content + 2);
						titleTxt = `${decodeKeyword}｜${titleTxt}`;

						if (thisSearchBrand) {
							// サイズ + 素材 + キーワード + ブランド
							breadHTML += setTopicPath(
								`${decodeSize}・${decodeMaterial}・${decodeKeyword}・${thisSearchBrandName}`,
								`?${thisSearchSize}&${thisSearchMaterial}&${thisSearchKeyword}&${thisSearchBrand}`, content + 3);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					} else {
						if (thisSearchBrand) {
							// サイズ + 素材 + ブランド
							breadHTML += setTopicPath(
								`${decodeSize}・${decodeMaterial}・${thisSearchBrandName}`,
								`?${thisSearchSize}&${thisSearchMaterial}&${thisSearchBrand}`, content + 3);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					}
				} else {
					if (thisSearchKeyword) {
						// サイズ + キーワード
						breadHTML += setTopicPath(`${decodeSize}・${decodeKeyword}`, `?${thisSearchSize}&${thisSearchKeyword}`, content + 1);
						titleTxt = `${decodeKeyword}｜${titleTxt}`;

						if (thisSearchBrand) {
							// サイズ + キーワード + ブランド
							breadHTML += setTopicPath(`${decodeSize}・${decodeKeyword}・${thisSearchBrandName}`,
								`?${thisSearchSize}&${thisSearchKeyword}&${thisSearchBrand}`, content + 2);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					} else {
						if (thisSearchBrand) {
							// サイズ + ブランド
							breadHTML += setTopicPath(`${decodeSize}・${thisSearchBrandName}`,
								`?${thisSearchSize}&${thisSearchBrand}`, content + 1);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					}
				}
			} else {
				if (thisSearchMaterial) {
					// 素材
					breadHTML += setTopicPath(decodeMaterial, `?${thisSearchMaterial}`, content);
					titleTxt = `${decodeMaterial}｜${titleTxt}`;

					if (thisSearchKeyword) {
						// 素材 + キーワード
						breadHTML += setTopicPath(`${decodeMaterial}・${decodeKeyword}`, `?${thisSearchMaterial}&${thisSearchKeyword}`, content + 1);
						titleTxt = `${decodeKeyword}｜${titleTxt}`;

						if (thisSearchBrand) {
							// 素材 + キーワード + ブランド
							breadHTML += setTopicPath(`${decodeMaterial}・${decodeKeyword}・${thisSearchBrandName}`,
								`?${thisSearchMaterial}&${thisSearchKeyword}&${thisSearchBrand}`, content + 2);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					} else {
						if (thisSearchBrand) {
							// 素材 + ブランド
							breadHTML += setTopicPath(`${decodeMaterial}・${thisSearchBrandName}`, `?${thisSearchMaterial}&${thisSearchBrand}`, content + 1);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					}
				} else {
					if (thisSearchKeyword) {
						// キーワード
						breadHTML += setTopicPath(decodeKeyword, `?${thisSearchKeyword}`, content);
						titleTxt = `${decodeKeyword}｜${titleTxt}`;

						if (thisSearchBrand) {
							// キーワード + ブランド
							breadHTML += setTopicPath(`${decodeKeyword}・${thisSearchBrandName}`, `?${thisSearchKeyword}&${thisSearchBrand}`, content + 1);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					} else {
						if (thisSearchBrand) {
							// ブランド
							breadHTML += setTopicPath(thisSearchBrandName, `?${thisSearchBrand}`, content);
							titleTxt = `${thisSearchBrandName}｜${titleTxt}`;
						}
					}
				}
			}
			$('.mod-topicPath-ul').append(breadHTML);
			$('title').text(titleTxt);
		}

		// SEO：クロール用リンク
		let crawlHTML = '<a href="' + NSKW.va.pathname + '" class="di_none">クロール用</a>';
		$('.js-searchSelect[data-name="size"]').each(function () {
			if (search.indexOf('size=' + encodeURIComponent($(this).text())) === -1) {
				crawlHTML += '<a href="' + NSKW.va.pathname + '?size=' + encodeURIComponent($(this).text());
				if (thisSearchMaterial) { crawlHTML += '&' + thisSearchMaterial; }
				if (thisSearchKeyword) { crawlHTML += '&' + thisSearchKeyword; }
				if (thisSearchBrand) { crawlHTML += '&' + thisSearchBrand; }
				crawlHTML += '" class="di_none">クロール用</a>';
			}
		});
		$('.js-searchSelect[data-name="material"]').each(function () {
			if (search.indexOf('material=' + encodeURIComponent($(this).text())) === -1) {
				crawlHTML += '<a href="' + NSKW.va.pathname + '?material=' + encodeURIComponent($(this).text());
				if (thisSearchSize) { crawlHTML += '&' + thisSearchSize; }
				if (thisSearchKeyword) { crawlHTML += '&' + thisSearchKeyword; }
				if (thisSearchBrand) { crawlHTML += '&' + thisSearchBrand; }
				crawlHTML += '" class="di_none">クロール用</a>';
			}
		});
		$('.js-searchSelect[data-name="keyword"]').each(function () {
			if (search.indexOf('keyword=' + encodeURIComponent($(this).text())) === -1) {
				crawlHTML += '<a href="' + NSKW.va.pathname + '?keyword=' + encodeURIComponent($(this).text());
				if (thisSearchSize) { crawlHTML += '&' + thisSearchSize; }
				if (thisSearchMaterial) { crawlHTML += '&' + thisSearchMaterial; }
				if (thisSearchBrand) { crawlHTML += '&' + thisSearchBrand; }
				crawlHTML += '" class="di_none">クロール用</a>';
			}
		});
		$('.js-searchSelect[data-name="brand"]').each(function () {
			if (search.indexOf('brand=' + encodeURIComponent($(this).attr('data-value'))) === -1) {
				crawlHTML += '<a href="' + NSKW.va.pathname + '?brand=' + $(this).attr('data-value');
				if (thisSearchSize) { crawlHTML += '&' + thisSearchSize; }
				if (thisSearchMaterial) { crawlHTML += '&' + thisSearchMaterial; }
				if (thisSearchKeyword) { crawlHTML += '&' + thisSearchKeyword; }
				crawlHTML += '" class="di_none">クロール用</a>';
			}
		});
		$('.categories-searchBox').after(crawlHTML);

		// クリアボタン
		$('.categories-searchBox-clear a').attr('href', NSKW.va.pathname);

		// 条件クリック時
		$('.js-searchSelect').on('click', function () {
			let $this = $(this);
			if (!$this.hasClass(a)) {
				let thisText;
				if ($this.attr('data-name') === 'brand') {
					thisText = $this.attr('data-value');
				} else {
					thisText = encodeURIComponent($this.text());
				}
				let name = $this.attr('data-name');
				let newSearch = '?';

				switch (name) {
					case 'size':
						newSearch += 'size=' + thisText + '&';
						if (thisSearchMaterial) { newSearch += thisSearchMaterial + '&'; }
						if (thisSearchKeyword) { newSearch += thisSearchKeyword + '&'; }
						if (thisSearchBrand) { newSearch += thisSearchBrand + '&'; }
						break;

					case 'material':
						if (thisSearchSize) { newSearch += thisSearchSize + '&'; }
						newSearch += 'material=' + thisText + '&';
						if (thisSearchKeyword) { newSearch += thisSearchKeyword + '&'; }
						if (thisSearchBrand) { newSearch += thisSearchBrand + '&'; }
						break;

					case 'keyword':
						if (thisSearchSize) { newSearch += thisSearchSize + '&'; }
						if (thisSearchMaterial) { newSearch += thisSearchMaterial + '&'; }
						newSearch += 'keyword=' + thisText + '&';
						if (thisSearchBrand) { newSearch += thisSearchBrand + '&'; }
						break;

					case 'brand':
						if (thisSearchSize) { newSearch += thisSearchSize + '&'; }
						if (thisSearchMaterial) { newSearch += thisSearchMaterial + '&'; }
						if (thisSearchKeyword) { newSearch += thisSearchKeyword + '&'; }
						newSearch += 'brand=' + thisText + '&';
						break;

					default:
						break;
				}
				location.href = NSKW.va.pathname + newSearch.slice(0, -1);
			}
		});

		// アコーディオン開閉
		if (NSKW.va.window.width > 767) {
			let $box = $('.categories-searchBox');
			let boxHeightDefault = $box.height() + 80;
			$box.css('height', boxHeightDefault);
			$('.categories-searchBox-btn').on('click', function () {
				let boxHeight = $('.categories-searchBox').height() + 80;
				let $thisDetail = $(this).next('div');
				let detailHeight = $thisDetail.height() + 62;
				if ($thisDetail.hasClass(a)) {
					$thisDetail.removeClass(a);
					$(this).removeClass(a);
					$box.css('height', boxHeight - detailHeight);
				} else {
					$('.categories-searchBox-btn').each(function () {
						$(this).removeClass(a);
						$(this).next('div').removeClass(a);
					});
					$(this).addClass(a);
					$box.css('height', boxHeightDefault + detailHeight);
					$thisDetail.addClass(a);
				}
			});
		} else {
			$('.categories-searchBox-btn').on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.categories-searchBox-detail').stop().slideToggle();
			});
		}
	};
	if (cat) {
		// ブランド絞り込み条件取得
		let brandSelectHTML = '';
		let jsonURL = cat === 'comforters' ? '/ajax/products/product_brand_comforters.json' : `/ajax/products/product_brand.json?p_category=${cat}`;

		$.when(
			$.getJSON(jsonURL, (data) => {
				for (let j = 0; j<data.rt_jbn_brand_list.length; j++) {
					brandSelectHTML += '<div class="js-searchSelect" data-name="brand" '+
						'data-value="'+ data.rt_jbn_brand_list[j]._key +'">'+ data.rt_jbn_brand_list[j].cf_pb_name_d +'</div>';
				}
			})
		).done(() => {
			$('.js-brandSelect').append(brandSelectHTML);
			setSearchItemsAndTopicPath();
		});
	}
	if (purpose) {
		setSearchItemsAndTopicPath();
	}

	// ＜カテゴリ一覧／目的別一覧＞おすすめショップ、おすすめサイト
	if (cat || purpose) {

		// バナーの出し分け
		let catMap = location.pathname.split('/')[3];

		$('.recommendBlock .mod-prodItem, .columnBlock .mod-prodItem').each(function(){
			if (cat) {
				if ($(this).attr('data-cat').indexOf(cat) === -1) {
					$(this).remove();
				}
			} else if (purpose) {
				if ($(this).attr('data-cat').indexOf(purpose) === -1) {
					$(this).remove();
				}
			}
			// detailItemのみ商品詳細ページにも表示する
			if (catMap !== '' && catMap !== 'index.html') {
				if ($(this).attr('class').indexOf('detailItem') === -1) {
					$(this).remove();
				}
			}
		});

		// recommendBlockの出し分け
		$('.recommendBlock').each(function(){
			if ($(this).find('.mod-prodItem')[0]) {
				$(this).children('.recommend-slider').owlCarousel({
					margin: 30,
					nav: true,
					loop: false,
					smartSpeed: 500,
					navText: navText,
					responsive: {
						640: {
							items: 4
						},
						320: {
							items: 1,
							stagePadding: 50
						}
					}
				});
			} else {
				$(this).remove();
			}
		});

		// columnBlockの出し分け
		$('.columnBlock').each(function(){
			if ($(this).find('.mod-prodItem')[0]) {
				$(this).children('.recommend-slider').owlCarousel({
					margin: 30,
					nav: true,
					loop: false,
					smartSpeed: 500,
					navText: navText,
					responsive: {
						640: {
							items: 3
						},
						320: {
							items: 1,
							stagePadding: 50
						}
					}
				});
			} else {
				$(this).remove();
			}
		});
	}

	// ＜カテゴリ一覧＞関連カテゴリリンク
	if (cat) {
		$.when(
			$.getJSON('/categories/relatedCategory.json', function(data){
				if (data.length) {
					let relatedCatHTML = '';
					for(let i = 0; i < data.length; i++) {
						if (data[i].category === cat) {
							for(let j = 0; j < data[i].related.length; j++) {
								relatedCatHTML += '<li><a href="' + data[i].related[j].url +
								'">' + data[i].related[j].label + '</a></li>';
							}
							$('.categories-relatedCat-list').append(relatedCatHTML);
							break;
						}
					}
					if (!relatedCatHTML) {
						$('.categories-relatedCat').remove();
					}
				} else {
					$('.categories-relatedCat').remove();
				}
			})
		);
	}

	// ＜カテゴリ一覧＞ 質問が無い場合「よくある質問」を非表示
		if (!($('.categories-faq-block').length)) {
		$('.categories-faq').addClass('di_none');
	}

	// ＜ブランド一覧＞メインビジュアルスライダー
	if (brand) {
		$('.brands-mainVis-slide').owlCarousel({
			items: 1,
			dots: true,
			autoplay: true,
			loop: true,
			smartSpeed: 1000,
			autoplayTimeout: 8000
		});
	}

	// ＜目的別一覧＞絞り込みがある場合詳細検索ボタンを削除
	if (purpose) {
		if ($('.categories-searchBox').length) {
			$('.mod-head02').find('.mod-button').remove();
		}
	}

	// ＜商品詳細＞各ブランドページリンク特設
	if (cat) {
		let $brandTitle = $('.js-products-brand-feature');
		if (!($brandTitle.length)) {
			$('.categories-detail-brand').remove();
		} else {
			$brandTitle.each(function(){
				let $this = $(this);
				let catBrand = $('.rt_cf_p_brand_cf_pb_key').text();
				let catResult = $this.attr('data-catBrand');
				if (catBrand === catResult) {
					$this.addClass('is-active');
				}
			});
		}
	}

	// ＜商品詳細検索＞
	if (map1 === 'products' && !tags) {
		if (searchArray.length > 0) {
			let paramCat, paramBrand;

			// 検索パラメータ：カテゴリをフォームに反映
			searchArray.forEach((val) => {
				if (val.indexOf('category') !== -1) {
					paramCat = val.replace(/category=/g, '');
				}
				if (val.indexOf('category_l') !== -1) {
					paramCat = val.replace(/category_l=/g, '');
					$('.js-selectCat').val(paramCat);
				}
				if (val.indexOf('purpose') !== -1) {
					paramCat = val.replace(/purpose=/g, '');
				}
				if (val.indexOf('brand') !== -1) {
					paramBrand = val.replace(/brand=/g, '');
				}
				if (val.indexOf('cond=close') !== -1) {
					// 検索ボックスを閉じる
					$('.js-toggle, .js-toggleBlock').removeClass(a);
				}
			});
			selectCat(paramCat, paramBrand);
		} else {
			getBrandSelect();
		}

		// ページングリンクにcond=closeパラメータを付与
		$('.mod-paginate').find('a').each((idx, ele) => {
			let href = $(ele).attr('href');
			$(ele).attr('href', href + '&cond=close');
		});

		// カテゴリ選択時切替
		$('.js-selectCat').on('change', (e) => {
			// 全てのチェックを外す
			$('.mod-check-input').prop('checked', false);
			$('.js-brandSelect').val('');

			selectCat($(e.currentTarget).val());
		});

		// クリアボタン押下時
		$('.js-clear').on('click', () => {
			getBrandSelect();
			$('.mod-check-input').prop('checked', false);
			$('.js-selectCat, .js-brandSelect').val('');
			$('[data-detail]').each((idx, ele) => {
				$(ele).find('.mod-check-input').prop('checked', false);
				$(ele).removeClass(a);
			});
			$('.js-checkSize').addClass(a);
			$('[data-size]').each((idx, ele) => {
				$(ele).addClass(a);
			});
		});
	}

	// ＜商品詳細＞お気に入り商品のアイコンを点灯
	$('.categories-detail-inner_variation .rt_bn_products_list').each(function(){
		if (checkFavo($(this).find('.rt_product_code').text())) {
			$(this).find('.js-favo').addClass(a);
		}
	});

	// ＜商品詳細＞お気に入りに追加・削除
	$('.js-favo').on('click', (e) => {
		let prodCode = $(e.currentTarget).parents('.rt_bn_products_list').find('.rt_product_code').text();
		if (!$(e.currentTarget).hasClass(a)) {
			let favoItemCnt = 0;
			for (let i in localStorage) {
				if (i.indexOf('favoriteList-') !== -1) {
					favoItemCnt++;
				}
			}
			if (favoItemCnt > 40) {
				alert('お気に入りの製品の登録は40件までです。お手数をおかけしますが製品の削除をお願いいたします。');
			} else {
				let favoDatetime = new Date();
				favoDatetime = favoDatetime.toLocaleString();
				localStorage.setItem('favoriteList-' + prodCode, favoDatetime);
				$(e.currentTarget).addClass(a);
			}
		} else {
			localStorage.removeItem('favoriteList-' + prodCode);
			$(e.currentTarget).removeClass(a);
		}
	});

	// ＜商品一覧共通＞お気に入り商品にアイコンを表示＆お気に入り追加・削除
	$('.js-prodItemList').find('.mod-prodItem').each((idx, ele) => {
		let thisProdCode = $(ele).find('.rt_product_code').text();
		let flgFavo = checkFavo(thisProdCode);
		if (flgFavo) {
			$(ele).find('.mod-prodItem-favo').find('.icon').removeClass('icon-favorite2'); // ♡
			$(ele).find('.mod-prodItem-favo').find('.icon').addClass('icon-favorite'); // ♥
		}
		$(ele).find('.mod-prodItem-favo').on('click', (e) => {
			if ($(e.currentTarget).find('.icon').hasClass('icon-favorite2')) { // お気に入りしてない → 追加
				let favoItemCnt = 0;
				for (let i in localStorage) {
					if (i.indexOf('favoriteList-') !== -1) {
						favoItemCnt++;
					}
				}
				if (favoItemCnt > 40) {
					alert('お気に入りの製品の登録は40件までです。お手数をおかけしますが製品の削除をお願いいたします。');
				} else {
					let favoDatetime = new Date();
					localStorage.setItem('favoriteList-' + thisProdCode, favoDatetime);
					$(e.currentTarget).find('.icon').removeClass('icon-favorite2').addClass('icon-favorite');
				}
			} else { // お気に入り済み → 削除
				localStorage.removeItem('favoriteList-' + thisProdCode);
				$(e.currentTarget).find('.icon').removeClass('icon-favorite').addClass('icon-favorite2');
			}
		});
	});

	// ＜お気に入り一覧＞お気に入り商品一覧表示
	if (location.pathname === '/categories/favorite.html') {
		getFavoList();
	}

	// ＜商品詳細＞現在ページを最近見た商品に追加
	if ($('.categories-detail-inner_variation .rt_bn_products_list')[0]) {
		addRecentStorage($('.categories-detail-inner_variation .rt_bn_products_list').eq(0).find('.rt_product_code').text());
	}

	// ＜商品詳細＞関連商品表示
	if ($('.categories-detail-inner_variation')[0]) {
		let thisCodeArr = [];
		$('.categories-detail-inner_variation .rt_bn_products_list').find('.rt_product_code').each(function(){
			thisCodeArr.push($(this).text());
		});
		getRelationList(
			$('.js-relationVal').find('.rt_p_category').text(),
			$('.js-relationVal').find('.rt_p_taste').text(),
			$('.js-relationVal').find('.rt_p_price').text(),
			thisCodeArr
		);
	}

	// ＜商品比較＞削除ボタン
	if (location.pathname.indexOf('/products/compare/') !== -1 || location.pathname === '/products/template_compare.html') {
		$('.js-remove').each((idx, ele) => {
			$(ele).on('click', (e) => {
				$(e.currentTarget).parents('.__item').remove();
			});
		});
	}

	/* ---------------------------------------------- functions ---------------------------------------------- */

	// ＜商品詳細検索＞カテゴリ選択でブランド選択／詳細チェックを表示
	function selectCat(_value, _brand){
		// ブランド
		getBrandSelect(_value, _brand);

		if (_value) {
			// サイズ
			$('.js-checkSize').removeClass(a);
			$('[data-size]').each(function(){
				$(this).removeClass(a);
			});
			if (_value === 'towel') {
				$('[data-size=towel]').addClass(a);
				$('.js-checkSize').addClass(a);
			} else if (_value === 'pillow') {
				$('[data-size=pillow]').addClass(a);
				$('.js-checkSize').addClass(a);
			} else if (_value === 'comforters' || _value === 'down' || _value === 'synthetic' || _value === 'silk' ||
				_value === 'ramie' || _value === 'floor-mattress' || _value === 'bed-mattress' ||
				_value === 'cover' || _value === 'blanket' || _value === 'pad' ||
				_value === 'overlay' || _value === 'bed' || _value === 'wool') {
				$('[data-size=bed]').addClass(a);
				$('.js-checkSize').addClass(a);
			} else if (_value === 'baby-junior' || _value === 'bedspread' || _value === 'halfket' ||
				_value === 'vest'	|| _value === 'maintenance' || _value === 'cushion' ||
				_value === 'relaxation' || _value === 'other') {
				$('.js-checkSize').removeClass(a);
			} else {
				$('[data-size]').addClass(a);
				$('.js-checkSize').addClass(a);
			}

			// 掛け布団全般の場合、クエリnameをcategory_lにする
			if (_value === 'comforters') {
				$('.js-selectCat').attr('name', 'category_l');
			} else {
				$('.js-selectCat').attr('name', 'category');
			}

			// 他、カテゴリごとのチェック項目
			$('[data-detail]').each(function(){
				let $this = $(this);
				if ($this.attr('data-detail') !== _value) {
					// 該当カテゴリ以外のチェックはすべて外す ※重複があるため
					$this.find('.mod-check-input').prop('checked', false);
					$this.removeClass(a);
				} else {
					$this.addClass(a);
				}
			});
		} else {
			$('.js-checkSize').addClass(a);
			$('[data-size]').each(function(){
				$(this).addClass(a);
			});
		}
	}

	// ＜商品詳細検索＞ブランド取得
	function getBrandSelect(_cat, _brand){
		let searchBrandSelectHTML = '';
		if (!_cat) { _cat = ''; }
		$('.js-brandSelect').find('option').remove();
		$('.js-brandSelect').append('<option value="">選択してください</option>');

		let jsonURL = _cat === 'comforters' ? '/ajax/products/product_brand_comforters.json' : `/ajax/products/product_brand.json?p_category=${_cat}`;
		$.when(
			$.getJSON(jsonURL, (data) => {
				for (let j = 0; j < data.rt_jbn_brand_list.length; j++) {
					searchBrandSelectHTML += `<option value="${data.rt_jbn_brand_list[j]._key}">${data.rt_jbn_brand_list[j].cf_pb_name_d}</option>`;
				}
			})
		).done(function(){
			$('.js-brandSelect').append(searchBrandSelectHTML);
			if (_brand) {
				$('.js-brandSelect').val(_brand);
			}
		});
	}

	// ＜共通＞最近見た商品に追加
	function addRecentStorage(_thisCode){
		let watchDatetime = new Date();
		watchDatetime = watchDatetime.toLocaleString();
		localStorage.setItem('recentList-' + _thisCode, watchDatetime);
	}

	// ＜共通＞最近見た商品から削除
	function removeRecentThisItem(_thisCode){
		localStorage.removeItem('recentList-'+_thisCode);
	}

	// ＜共通＞関連商品表示
	function getRelationList(_cat, _taste, _price, _thisCodeArr){
		let relList = [];
		let jsonPathRel = '/ajax/products/related_products.json?p_category=' + _cat;

		// テイストはカバーのみ
		if (_taste && _cat === 'cover') { jsonPathRel += '&p_taste=' + _taste; }

		// 価格を条件に含めないカテゴリ
		if (_cat === 'overlay' || _cat === 'towel' || _cat === 'baby-junior' || _cat === 'bed' || _cat === 'bedspread' ||
			_cat === 'maintenance' || _cat === 'cushion' || _cat === 'relaxation' || _cat === 'other') {
			_price = '';
		}

		if (_price) {
			if (_cat === 'down') {
				if (_price < 50000) {
					_price = '_50001';
				} else if (_price >= 50000 && _price < 300000) {
					_price = '50000_300001';
				} else if (_price >= 300000) {
					_price = '300000_';
				}
			} else if (_cat === 'synthetic') {
				if (_price < 10000) {
					_price = '_10001';
				} else if (_price >= 10000 && _price < 20000) {
					_price = '10000_20001';
				} else if (_price >= 20000) {
					_price = '20000_';
				}
			} else if (_cat === 'silk') {
				if (_price < 100000) {
					_price = '_100001';
				} else if (_price >= 10000 && _price < 20000) {
					_price = '10000_20001';
				} else if (_price >= 20000) {
					_price = '20000_';
				}
			} else if (_cat === 'ramie') {
				if (_price < 50000) {
					_price = '_50001';
				} else if (_price >= 50000 && _price < 300000) {
					_price = '50000_300001';
				} else if (_price >= 300000) {
					_price = '300000_';
				}
			} else if (_cat === 'floor-mattress') {
				if (_price < 50000) {
					_price = '_50001';
				} else if (_price >= 50000) {
					_price = '50000_';
				}
			} else if (_cat === 'bed-mattress') {
				if (_price < 100000) {
					_price = '_100001';
				} else if (_price >= 100000) {
					_price = '100000_';
				}
			} else if (_cat === 'pillow' || _cat === 'cover') {
				if (_price < 10000) {
					_price = '_10001';
				} else if (_price >= 10000 && _price < 20000) {
					_price = '10000_20001';
				} else if (_price >= 20000) {
					_price = '20000_';
				}
			} else if (_cat === 'blanket') {
				if (_price < 10000) {
					_price = '_10001';
				} else if (_price >= 10000 && _price < 50000) {
					_price = '10000_50001';
				} else if (_price >= 50000) {
					_price = '50000_';
				}
			} else if (_cat === 'pad') {
				if (_price < 10000) {
					_price = '_10001';
				} else if (_price >= 10000) {
					_price = '10000_';
				}
			} else if (_cat === 'halfket') {
				if (_price < 5000) {
					_price = '_5001';
				} else if (_price >= 5000) {
					_price = '5000_';
				}
			}
			jsonPathRel += '&p_price=' + _price;
		}
		$.when(
			$.getJSON(jsonPathRel, function(data){
				let arrCnt = 0;
				for(let j=0; j<data.rt_bn_products_list.length; j++) {
					let prodCode = data.rt_bn_products_list[j]._key;
					let sameFlg = false; // 表示中の商品と同一コードのものは除外
					for(let k=0; k<_thisCodeArr.length; k++) {
						if (prodCode === _thisCodeArr[k]) { sameFlg = true; }
					}
					if (!sameFlg) {
						let relImg = '/categories/product_file/file/' + data.rt_bn_products_list[j].cf_p_img_main;
						if (!relImg) { relImg = '/categories/product_file/file/no_image.jpg'; }
						relList[arrCnt] = {
							code: prodCode,
							patternCode: data.rt_bn_products_list[j].cf_p_pattern_code,
							img: relImg,
							brand: data.rt_bn_products_list[j].cf_p_brand.cf_pb_name_d,
							name: data.rt_bn_products_list[j].cf_p_name_d,
							price: data.rt_bn_products_list[j].cf_p_price,
							keywords: data.rt_bn_products_list[j].cf_p_keywords,
							cat: data.rt_bn_products_list[j].cf_p_category._key,
							catName: data.rt_bn_products_list[j].cf_p_category.cf_pc_name_d,
							size: data.rt_bn_products_list[j].cf_p_size_d,
							recFlg: data.rt_bn_products_list[j].cf_p_recommend_flg,
							newFlg: data.rt_bn_products_list[j].cf_p_new_flg,
							prodID: data.rt_bn_products_list[j].cf_p_item_id
						};
						arrCnt++;
					}
				}
			})
		).done(function(){
			let listLength = relList.length;
			if (listLength > 0) {
				let cnt;
				if (listLength > 10) { cnt = 10; } else { cnt = listLength; }
				let relHTML = '';
				for (let j=0; j<cnt; j++) {
					relHTML += '<div class="mod-prodItem opacity">'+
						`<a href="/categories/${relList[j].cat}/${relList[j].prodID}/" class="di_block">` +
						'<figure class="mod-prodItem-img"><div>' +
						`<img src="${relList[j].img}" alt="${relList[j].patternCode} ${relList[j].name}" title="${relList[j].patternCode} ${relList[j].name}"></div>`;
					if (checkFavo(relList[j].prodID)) {
						relHTML += '<span class="mod-prodItem-favo is-active"><i class="icon icon-new"></i><i class="icon icon-favorite"></i></span>';
					}
					relHTML += '<figcaption>';
					if (relList[j].brand && relList[j].brand !== 'No Brand') {
						relHTML += relList[j].brand;
					}
					relHTML +=	'</figcaption></figure><div class="mod-prodItem-mark">';
					if (relList[j].newFlg) {
						relHTML += '<span class="mod-prodItem-label new"><i class="icon icon-new"></i>NEW</span>';
					}
					if (relList[j].recFlg) {
						relHTML += '<span class="mod-prodItem-label recommend"><i class="icon icon-recommend"></i>おすすめ</span>';
					}
					relHTML += `</div><div class="mod-prodItem-text"><span class="mod-prodItem-name">${relList[j].name}</span>`;
					if (relList[j].keywords.indexOf('オープン価格') !== -1) {
						relHTML += '<span class="mod-prodItem-price">オープン価格</span></div></a>';
					} else {
						relHTML += `<span class="mod-prodItem-price">￥${relList[j].price}<span>（税込）</span></span></div></a>`;
					}
					relHTML += '<div class="mod-prodItem-tag">'+
						`<a class="mod-prodItem-label" href="/categories/${relList[j].cat}/"><i class="icon icon-tag"></i><span>${relList[j].catName}</span></a>`;
					if (relList[j].size) {
						relHTML += `<a class="mod-prodItem-label"><i class="icon icon-tag"></i><span>${relList[j].size}</span></a>`;
					}
					relHTML += '</div></div>';
				}

				$('.categories-relation-slider').append(relHTML);
				$('.categories-relation-slider .mod-prodItem figcaption').matchHeight();
				$('.categories-relation-slider .mod-prodItem-mark').matchHeight();
				$('.categories-relation-slider .mod-prodItem-name').matchHeight();

				// カルーセル作成
				$('.categories-relation-slider').owlCarousel({
					margin: 30,
					nav: true,
					loop: false,
					smartSpeed: 500,
					navText: navText,
					responsive: {
						640: {
							items: 4
						},
						320: {
							items: 1,
							stagePadding: 50
						}
					}
				});
			} else {
				$('.categories-relation').remove();
			}
		});
	}

	// ＜共通＞お気に入り商品かチェック
	function checkFavo(_thisProdCode){
		for(let item in localStorage) {
			if (item.indexOf('favoriteList-') !== -1) {
				if (item.replace(/favoriteList-/, '') === _thisProdCode) {
					return true;
				}
			}
		}
		return false;
	}

	// ＜お気に入り一覧＞localStorageからお気に入りリスト取得 { favoriteList-prodCode, datetime } → 商品コードから各JSON取得
	function getFavoList() {
		let favoStorage = [], favoStorageNew = [];
		let favoList = [];

		for (let i in localStorage) {
			if (i.indexOf('favoriteList-') !== -1) {
				favoStorage.push({
					idx: i,
					datetime: localStorage[i]
				});
			}
		}
		if (favoStorage.length) {
			favoStorage.sort(
				function(x, y){
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return (-1);
					if (xDate < yDate) return 1;
					return 0;
				}
			);
			for (let k=0; k<favoStorage.length; k++) {
				if (k <= 40) {
					favoStorageNew.push(favoStorage[k].idx);
				} else {
					localStorage.removeItem(favoStorage[k].idx);
				}
			}
		}
		if (favoStorageNew.length > 0) {
			let jsonParam = '';
			$.each(favoStorageNew, function(key, val){
				jsonParam += 'product_code=' + val.replace(/favoriteList-/, '') + '&';
			});
			jsonParam = jsonParam.slice(0, -1);

			$.when(
				$.getJSON('/ajax/products/search.json?'+ jsonParam, function(data){
					for(let j=0; j<data.rt_bn_products_list.length; j++) {
						let prodCode = data.rt_bn_products_list[j]._key;
						let favoImg = '/categories/product_file/file/' + data.rt_bn_products_list[j].cf_p_img_main;
						if (!favoImg) { favoImg = '/categories/product_file/file/no_image.jpg'; }
						favoList[j] = {
							datetime: localStorage['favoriteList-' + prodCode],
							code: prodCode,
							patternCode: data.rt_bn_products_list[j].cf_p_pattern_code,
							img: favoImg,
							brand: data.rt_bn_products_list[j].cf_p_brand.cf_pb_name_d,
							name: data.rt_bn_products_list[j].cf_p_name_d,
							price: data.rt_bn_products_list[j].cf_p_price,
							keywords: data.rt_bn_products_list[j].cf_p_keywords,
							cat: data.rt_bn_products_list[j].cf_p_category._key,
							catName: data.rt_bn_products_list[j].cf_p_category.cf_pc_name_d,
							sizetxt: data.rt_bn_products_list[j].cf_p_size_d,
							sizes: data.rt_bn_products_list[j].cf_p_sizes,
							recFlg: data.rt_bn_products_list[j].cf_p_recommend_flg,
							newFlg: data.rt_bn_products_list[j].cf_p_new_flg,
							prodID: data.rt_bn_products_list[j].cf_p_item_id
						};
					}
				})
			).done(function(){
				favoList.sort(
					function(x, y){
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if (xDate > yDate) return-1;
						if (xDate < yDate) return 1;
						return 0;
					}
				);
				if (favoList.length > 20) {
					localStorage.removeItem('favoriteList-'+ favoList[15].prod);
					favoList.pop();
				}

				// console.dir(favoList);

				let favoHTML = '';

				for(let j=0; j<favoList.length; j++) {
					favoHTML += '<li class="pure-u-1-4 pure-u-lg-1-3 pure-u-md-1-2 space-u-40-child">'+
						'<div class="mod-prodItem opacity">'+
						`<a href="/categories/${favoList[j].cat}/${favoList[j].prodID}/" class="di_block">`+
						'<figure class="mod-prodItem-img"><div>'+
						`<img src="${favoList[j].img}" alt="${favoList[j].patternCode} ${favoList[j].name}" title="${favoList[j].patternCode} ${favoList[j].name}"></div><figcaption>`;
					if (favoList[j].brand && favoList[j].brand !== 'No Brand') {
						favoHTML += favoList[j].brand;
					}
					favoHTML += '</figcaption></figure><div class="mod-prodItem-mark">';
					if (favoList[j].newFlg) {
						favoHTML += '<span class="mod-prodItem-label new"><i class="icon icon-new"></i>NEW</span>';
					}
					if (favoList[j].recFlg) {
						favoHTML += '<span class="mod-prodItem-label recommend"><i class="icon icon-recommend"></i>おすすめ</span>';
					}
					favoHTML += '</div>'+
						`<div class="mod-prodItem-text"><span class="di_none js-prodCode">${favoList[j].code}</span>` +
						`<span class="mod-prodItem-code">${favoList[j].patternCode}</span>` +
						`<span class="mod-prodItem-name">${favoList[j].name}</span>`;
					if (favoList[j].keywords.indexOf('オープン価格') !== -1) {
						favoHTML += '<span class="mod-prodItem-price">オープン価格</span></div></a>';
					} else {
						favoHTML += `<span class="mod-prodItem-price">￥${favoList[j].price}<span>（税込）</span></span></div></a>`;
					}

					favoHTML += '<div class="mod-prodItem-tag">' +
						'<span class="mod-prodItem-favo"><i class="icon icon-favorite"></i></span>' +
						`<a class="mod-prodItem-label" href="/categories/${favoList[j].cat}/"><i class="icon icon-tag"></i>` +
						`<span>${favoList[j].catName}</span></a>` +
						`<span class="di_none rt_cf_p_category_key">${favoList[j].cat}</span>`;
					if (favoList[j].sizetxt) {
						favoHTML += `<span class="di_none cf_p_sizes">${favoList[j].sizes}</span>` +
						`<a class="mod-prodItem-label _size" href=""><i class="icon icon-tag"></i><span>${favoList[j].sizetxt}</span></a>`;
					}
					favoHTML += '</div>';

					// 比較チェックボタン
					favoHTML += '<div class="mod-prodItem-check">' +
						`<label for="${favoList[j].code}" class="mod-check">` +
						`<input type="checkbox" name="favorite-compare" id="${favoList[j].code}" class="mod-check-input" `;

					if (favoList[j].cat === 'down' || favoList[j].cat === 'synthetic' || favoList[j].cat === 'silk' ||
						favoList[j].cat === 'ramie' || favoList[j].cat === 'wool') {
						favoHTML += `data-category="comforters">`;
					} else {
						favoHTML += `data-category="${favoList[j].cat}">`;
					}
					favoHTML += '<span class="mod-check-text">比較する</span></label></div>';

					favoHTML += '</li>';
				}

				$('.categories-favorite-list').append(favoHTML);
				$('.categories-favorite-list .mod-prodItem-mark').matchHeight();
				$('.categories-favorite-list .mod-prodItem figcaption').matchHeight();
				$('.categories-favorite-list .mod-prodItem-name').matchHeight();

				checkSizeTagLink();
				checkCompare();

				// お気に入りボタンクリックで削除（リロード）
				$('.mod-prodItem-favo').each((idx, ele) => {
					$(ele).on('click', () => {
						let prodCode = $(ele).parents('.mod-prodItem').find('.js-prodCode').text();
						localStorage.removeItem('favoriteList-' + prodCode);
						location.reload();
					});
				});

			});
		} else {
			$('.categories-favorite-noItem').addClass(v);
		}
	}

	// ＜一覧系＞サイズタグリンク作成
	function getJSONSize() {
		return $.getJSON('/ajax/product/size.json');
	}
	function checkSizeTagLink() {
		let sizeList;
		getJSONSize().then((data) => {
			sizeList = data.rt_bn_product_size;

			$('.mod-prodItem').each((idx, ele) => {
				let $thisTag = $(ele).find('.mod-prodItem-label._size');
				if ($thisTag[0]) {
					let thisSizeTxt = $(ele).find('.mod-prodItem-tag .cf_p_sizes').text();
					let thisItemCat = $(ele).find('.mod-prodItem-tag .rt_cf_p_category_key').text();
					for (let i = 0; i < sizeList.length; i++) {
						if (sizeList[i]._key === thisItemCat && sizeList[i].p_size[0].size) {
							let thisCatSizeList = sizeList[i].p_size[0].size;
							for (let j = 0; j < thisCatSizeList.length; j++) {
								if (thisSizeTxt === thisCatSizeList[j]) {
									$thisTag.attr('href', `/categories/${thisItemCat}/?size=${thisCatSizeList[j]}`);
									break;
								}
							}
						}
					}
				}
			});
		});
	}

	// ＜お気に入り一覧＞比較チェック処理
	function checkCompare() {
		let compareCat = '', checkItemCnt = 0;
		$('input[name="favorite-compare"]').change((e) => {
			if ($(e.currentTarget).prop('checked')) {
				if (compareCat) {
					if (checkItemCnt < 5) { checkItemCnt++; }
				} else {
					compareCat = $(e.currentTarget).attr('data-category');
					checkItemCnt++;
				}
			} else {
				checkItemCnt--;
				if (checkItemCnt === 0) {
					compareCat = '';
				}
			}
			// console.log(checkItemCnt);

			if (compareCat && checkItemCnt >= 2) {
				$('.categories-favorite-compareBtn').find('a').removeClass('mod-button-a_white').addClass('mod-button-a_red');
			} else {
				$('.categories-favorite-compareBtn').find('a').removeClass('mod-button-a_red').addClass('mod-button-a_white');
			}

			let compareURL = `/products/compare/${compareCat}/?`;
			let checkIdx = 0;
			$('input[name="favorite-compare"]').each((idx, ele) => {
				if (compareCat) {
					if (checkItemCnt >= 5) {
						if ($(ele).prop('checked')) {
							compareURL += `p_product_id${++checkIdx}=${$(ele).parents('.mod-prodItem').find('.js-prodCode').text()}&`;
						} else {
							$(ele).prop('disabled', true);
							$(ele).parent('.mod-check').addClass('is-disabled');
						}
					} else {
						if ($(ele).attr('data-category') !== compareCat) {
							$(ele).prop('disabled', true);
							$(ele).parent('.mod-check').addClass('is-disabled');
						} else {
							$(ele).prop('disabled', false);
							$(ele).parent('.mod-check').removeClass('is-disabled');
						}
						if ($(ele).prop('checked')) {
							$(ele).parent('.mod-check').addClass('is-checked');
							compareURL += `p_product_id${++checkIdx}=${$(ele).parents('.mod-prodItem').find('.js-prodCode').text()}&`;
						} else {
							$(ele).parent('.mod-check').removeClass('is-checked');
						}
					}
				} else {
					$(ele).prop('disabled', false);
					$(ele).parent('.mod-check').removeClass('is-disabled').removeClass('is-checked');
				}
			});
			compareURL = compareURL.slice(0, -1);
			$('.categories-favorite-compareBtn').find('a').attr('href', compareURL);
		});
	}

})(window.jQuery, window.NSKW, window.cssua);
